<ng-template #templateRef>
    <form #editorForm="ngForm" name="editCountry" (ngSubmit)="save()" id="crmCountryEditor">
        <h2 mat-dialog-title i18n="Country Editor Dialog | Title">{{Copy && Copy.Id ? 'Edit' : 'Add'}} country</h2>
        <mat-dialog-content *ngIf="Copy">
            <div class="row">
              <div class="col-md-2">
                <mat-form-field>
                  <mat-label>Id</mat-label>
                  <input [(ngModel)]="Copy.Id" matInput name="Id">
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field>
                  <mat-label>Name</mat-label>
                  <input matInput name="Name" [(ngModel)]="Copy.Name">
                </mat-form-field>
              </div>
              <div class="col-md-3">
                <mat-form-field>
                  <mat-label>Postcode pattern</mat-label>
                  <input [matAutocomplete]="auto" matInput name="PostcodePattern" [(ngModel)]="Copy.PostcodePattern">
                  <button type="button" mat-icon-button matIconSuffix (click)="goToDocumentation()" matTooltip="Link to regex documentation">
                    <mat-icon>link</mat-icon>
                  </button>
                  <mat-autocomplete #auto>
                    <mat-option value="\d{4}">\d{{'{'}}4&#125;= 4 numbers => 8500</mat-option>
                    <mat-option value="\d{4}\s[A-Z]{2}">\d{{'{'}}4&#125;\s[A-Z]{{'{'}}2&#125;= 4 numbers AND 2 letters => 1234 AB</mat-option>
                    <mat-option value="(\d{5}-\d{4}|\d{5})">(\d{{'{'}}5&#125;-\d{{'{'}}4&#125;|\d{{'{'}}5&#125;)= 5 numbers OR 5 numbers-4 numbers => 12345 or 12345-6789</mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              <div class="col-md-3">
                <mat-form-field>
                  <mat-label>Postcode example</mat-label>
                  <input [(ngModel)]="Copy.PostcodeExample" matInput maxlength="100" name="PostcodeExample" placeholder="Postcode Example">
                </mat-form-field>
              </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <mat-form-field>
                      <mat-label>Iso Code</mat-label>
                        <input matInput name="IsoCode"
                               [(ngModel)]="Copy.IsoCode">
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <app-article-selector [(ngModel)]="Copy.ShipmentArticle"
                                          name="ShipmentArticle" placeholder="Shipment Article"></app-article-selector>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <mat-form-field>
                      <mat-label>Pallet Shipment From kg</mat-label>
                      <input matInput name="PalletShipmentFrom"
                             [(ngModel)]="Copy.PalletShipmentFrom" type="number">
                    </mat-form-field>
                </div>
              <div class="col-md-6">
                <mat-form-field>
                  <mat-label>Shipment Franco From €</mat-label>
                  <input matInput name="ShipmentFranco"
                         [(ngModel)]="Copy.ShipmentFranco" type="number">
                </mat-form-field>
              </div>
            </div>
          <div class="row">
            <div class="col-md-12">
              <mat-checkbox [(ngModel)]="Copy.IsContactable" name="IsContactable">Contact button on Reseller</mat-checkbox>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Contact mobile</mat-label>
                <input [(ngModel)]="Copy.ContactMobile" matInput name="ContactMobile"
                       type="text">
                <mat-hint>This number is shown in the contact window if it is displayed on the Reseller platform.</mat-hint>
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Contact E-mail</mat-label>
                <input [(ngModel)]="Copy.ContactEmail" matInput name="ContactEmail"
                       placeholder="Contact Email" type="text">
                <mat-hint>This email is shown in the contact window if it is displayed on the Reseller platform.</mat-hint>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <app-translation-field-editor title="Name"
                                          [(List)]="Copy.Translations"></app-translation-field-editor>
          </div>
        </mat-dialog-content>
        <mat-dialog-actions>
            <div class="fill-remaining-space"></div>
            <button mat-button mat-raised-button [mat-dialog-close]="true" i18n="@@ButtonClose">
                Close
            </button>
            <app-button [disabled]="!editorForm.form.valid" [isLoading]="isLoading"></app-button>
        </mat-dialog-actions>
    </form>
</ng-template>
